(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-us-sliders"] && !Shopify.designMode) return;
  try {
    
      document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined'){
    new Swiper('.contact-us-swiper', {
        initialSlide: 0,
        slidesPerView: 'auto',
        spaceBetween: 32
    });
  }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards_form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      new Swiper('.rewards-form__swiper', {
        initialSlide: 1,
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: {
          enabled: true,
          momentumRatio: 0.8,
        },
        grabCursor: true,
        resistance: false,
        simulateTouch: true
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  // ========== Markers ==========
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".size-guide__marker-menu-item");

  items.forEach(item => {
    item.addEventListener("click", () => {
      const markerClass = item.dataset.marker + "-marker";
      const allMarkers = document.querySelectorAll(".size-guide__marker");

      allMarkers.forEach(marker => marker.classList.remove("active"));

      const target = document.querySelector(`.${markerClass}`);
      if (target) {
        target.classList.add("active");
      }
      // ========== Menu item ==========
      items.forEach(i => i.querySelector("h3").classList.remove("active-title"));

      const h4 = item.querySelector("h3");
      if (h4) {
        h4.classList.add("active-title");
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-to-miami"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
      if (typeof Swiper !== 'undefined') {
          new Swiper('.welcome__swiper', {
              initialSlide: 1,
              slidesPerView: 'auto',
              spaceBetween: 0,
              freeMode: {
                  enabled: true,
                momentumRatio: 0.8
              },
            grabCursor: true,
            resistance: false,
            simulateTouch: true
          });
      }
  });

  } catch(e) { console.error(e); }
})();
})();
